<template>
    <div class="search-item-view">
        <div class="img">
            <img :src="goods.img" alt="">
            <span></span>
        </div>
        <div class="content">
            <p class="name">{{goods.name}}</p>
            <p class="keywords">{{goods.keywords}}</p>
            <p class="price">
                <span>${{goods.unitPrice}}</span>
                <span>單價 ${{goods.unitPrice}}</span>
            </p>
            <p class="other">
                <span v-if="goods.sale" class="sale">特價</span>
                <span class="appraise">{{goods.appraiseNum}}條評價</span>
                <span class="rate">{{goods.rateScore}}好評</span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'searchItemView',
        props: ['goods'],
        created() {

        },
    }
</script>

<style lang="scss">
    .search-item-view {
        margin: 10px;
        padding: 5px;
        background-color: #fff;
        box-shadow: 0 0 10px 0 gray;
        border-radius: 5px;
        display: flex;
        .img {
            width: 40%;
            min-width: 140px;
            img {
                width: 100%;
                vertical-align: middle;
            }
            span {
                width: 0;
                display: inline-block;
                height: 100%;
                vertical-align: middle;
            }
        }
        .content {
            padding: 10px;
            .name {
                font-size: 16px;
                font-weight: 600;
                line-height: 19px;
            }
            .keywords {
                font-size: 13px;
                line-height: 23px;
                color: #ababab;
            }
            .price {
                line-height: 30px;
                span:nth-of-type(1) {
                    color: red;
                    font-size: 15px;
                    margin-right: 20px;
                }
                span:nth-of-type(2) {
                    color: #ababab;
                    font-size: 13px;
                }
            }
            .other {
                line-height: 17px;
                display: flex;
                justify-content: space-between;
                span {
                    color: #ababab;
                    font-size: 13px;
                    line-height: 19px;
                }
                .sale {
                    font-size: 11px;
                    line-height: 11px;
                    color: white;
                    background-color: red;
                    padding: 3px 5px;
                    border-radius: 10px;
                }
            }
        }
    }
</style>